<template>
    <div class="content-tags">
        <ContentTag v-for="(tag, tagIndex) in innerTags" :title="tag.title" :linkUrl="tag.link_url" :key="tagIndex"></ContentTag>
        <a @click="showAll" v-if="extraCount" class="content-tags__extra">+{{extraCount}}</a>
    </div>
</template>

<script>
    import ContentTag from './ContentTag'

    const MAX_DISPLAYED = 5;

    export default {
        name: 'ContentTags',
        props: {
            tags: {
                type: Array,
                default: () => []
            },
            max: {
                required: false,
                default: MAX_DISPLAYED,
                type: Number
            }
        },
        components: {
            ContentTag,
        },
        data () {
            return {
                innerTags: []
            };
        },
        computed: {
            extraCount () {
                return this.tags.length - this.innerTags.length
            }
        },
        methods: {
            showAll () {
                this.innerTags = this.tags.slice();
            },
            setTags (tags) {
                this.innerTags = tags.slice(0, this.max);
            }
        },

        mounted () {
            this.setTags(this.tags)
        },

        watch: {
            tags (newValue) {
               this.setTags(newValue)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content-tags {
        display: block;
        width: 100%;
        line-height: 100%;
        margin-top: 10px;
        margin-bottom: 10px;

        &__extra {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #999999;
            cursor: pointer;
        }
    }
</style>